import { render, staticRenderFns } from "./dailyNews.vue?vue&type=template&id=32227005&scoped=true"
import script from "./dailyNews.vue?vue&type=script&lang=js"
export * from "./dailyNews.vue?vue&type=script&lang=js"
import style0 from "./dailyNews.vue?vue&type=style&index=0&id=32227005&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32227005",
  null
  
)

export default component.exports